import type { SpinnerProps } from "@chakra-ui/react";
import { Box, Spinner as DeprecatedChakraSpinner } from "@chakra-ui/react";
import React from "react";
import { colours } from "@shared/ui.design-system";

interface Props extends SpinnerProps {
  color?: string;
  size?: string;
}

export const DeprecatedSpinner: React.FC<Props> = ({
  color = colours.accent.strong,
  size = "sm",
  ...props
}) => (
  <Box data-testid="spinner">
    <DeprecatedChakraSpinner color={color} size={size} {...props} />
  </Box>
);
